import { State } from 'src/redux/reducer';
import { isLoaded, isPending, isRejected } from 'src/redux/utils';

export const putTakingSurveySelector = (state: State) =>
  state.putTakingSurvey.entities;
export const putTakingSurveyStatusSelector = (state: State) =>
  state.putTakingSurvey.status;

export const putTakingSurveyLoadedSelector = isLoaded(
  putTakingSurveyStatusSelector,
);
export const putTakingSurveyRejectedSelector = isRejected(
  putTakingSurveyStatusSelector,
);
export const putTakingSurveyPendingSelector = isPending(
  putTakingSurveyStatusSelector,
);
